<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				ref="table"
				size='mini'
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					fixed="left"
					type="selection"
					align="center"
					width="50">
					</el-table-column>
				<el-table-column
					fixed="left"
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="50"
					align="center">
				</el-table-column>
				<el-table-column
					fixed="left"
					label="店铺编号"
					prop="code"
					min-width="110"
					align="center">
				</el-table-column>
				<el-table-column
					fixed="left"
					label="店铺名称"
					prop="name"
					min-width="180"
					align="center">
				</el-table-column>
				<template v-for="(item, index) in cols" >
					<el-table-column
						v-if="item.show"
						:key="`col_${index}`"
						:prop="item.prop"
						:label="item.label"
						:min-width="item.width"
						:align="item.align">
					</el-table-column>
				</template>
				<el-table-column label="关联商品" prop="pidcnt" width="100" align="center" v-if="viewAuthority">
					<template slot-scope="scope">
						<el-button size="mini" type="text" @click="goGoods(scope.row)">{{scope.row.pidcnt}}个</el-button>
					</template>
				</el-table-column>
				<el-table-column label="关联员工" prop="usercnt" width="100" align="center" v-if="viewAuthority">
					<template slot-scope="scope">
						<el-button size="mini" type="text" @click="goEmployees(scope.row)">{{scope.row.usercnt}}个</el-button>
					</template>
				</el-table-column>
				<el-table-column
					label="AppID"
					prop="wechatAppid"
					min-width="130"
					align="center">
				</el-table-column>
				<el-table-column label="操作" width="200" align="center" v-if="deleteAuthority || viewAuthority">
					<template slot-scope="scope">
						<el-button size="mini" type='text' icon="el-icon-delete" @click="handleDelete(scope.row)" v-if="deleteAuthority">删除</el-button>
						<el-button size="mini" type='text' icon="el-icon-search" @click="getDetail(scope.row)" v-if="viewAuthority">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
import { cols } from '@/js/business/storeSetting/storeSettingCols'
export default {
	name: 'mainTable',
	data () {
		return {
			tableHeight: '100%',
			cols: cols,
			pagination: {
				page: 1,
				size: 20
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			})
		}
	},
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number,
			default: 0
		},
		deleteAuthority: {
			type: Boolean
		},
		viewAuthority: {
			type: Boolean
		}
	},
	watch: {
		tableData: {
			handler (val) {
				this.$nextTick(() => {
					this.tableSelectUtils.setTableDefaultSelect(val, this.$refs.table)
				})
			},
			immediate: true
		}
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		rowClick (row, column, event) {
			this.getDetail(row)
		},
		handleSizeChange (val) {
			this.pagination.size = val
			this.$emit('handleSize', { size: val })
		},
		handlePageChange (val) {
			this.pagination.page = val
			this.$emit('handlePage', { page: val })
		},
		handleDelete (data) {
			this.$emit('handleDelete', data.id)
		},
		getDetail (data) {
			window.sessionStorage.setItem('storeid', data.id)
			window.sessionStorage.setItem('shopName', data.name)
			window.sessionStorage.setItem('isAdd', false)
			this.$emit('saveShop', true)
			this.$router.push('storeSetting')
		},
		goEmployees (data) {
			window.sessionStorage.setItem('storeid', data.id)
			window.sessionStorage.setItem('shopName', data.name)
			this.$router.push('storeSetting/relatedEmployees')
		},
		goGoods (data) {
			window.sessionStorage.setItem('storeid', data.id)
			window.sessionStorage.setItem('shopName', data.name)
			this.$router.push('storeSetting/relatedGoods')
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			this.$emit('handleSelection', data)
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.id
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	height :100%;
	.main-table-box {
		height:calc(100% - 60px);
		padding-bottom 10px;
		overflow-y: auto;
	}
	i {
		display inline-block
		width 20px
		height 20px
		vertical-align top
		background-position center
		&.related-goods {
			background-image: url('~images/icon/related-goods-icon.png')
		}
		&.related-employee {
			background-image: url('~images/icon/related-employee-icon.png')
		}
	}
}
</style>
